import * as React from 'react';
const SvgPause = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 10 14" fill="none" {...props}>
        <rect width={3} height={14} rx={1.5} fill="currentColor" />
        <rect x={7} width={3} height={14} rx={1.5} fill="currentColor" />
    </svg>
);
export default SvgPause;
